import Sessions from './Sessions';

export default Sessions;
